import { render, staticRenderFns } from "./scenic.vue?vue&type=template&id=4175495b&scoped=true"
var script = {}
import style0 from "./scenic.vue?vue&type=style&index=0&id=4175495b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4175495b",
  null
  
)

export default component.exports